import React, { Fragment } from 'react';
import cn from 'classnames';
import { Tooltip as AntTooltip, Icon } from 'antd';
import styles from './index.module.scss';

const IconTemplate = ({ tooltipTitle, iconType, onClick }) => {
  const Wrapper = tooltipTitle ? AntTooltip : Fragment;
  const wrapperProps = tooltipTitle ? { title: tooltipTitle } : {};

  return (
    <Wrapper {...wrapperProps}>
      <Icon
        type={iconType}
        onClick={onClick}
        className={cn(styles.icon, { [styles.interactive]: Boolean(onClick) })}
      />
    </Wrapper>
  );
};

export default IconTemplate;
